module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2-2"
  }, [_c('span', {
    staticClass: "blue1"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('div', {
    staticClass: "hr-bottom"
  }, [_c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "ded"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Dedication#ded-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062237088_Acknowledgments#ack-1"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "for"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062237088_Foreword#for-1"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "fr"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062237088_Frontmatter_1#fr-1"
    }
  }, [_vm._v("Before You Begin: The Heart of Your Wedding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-2",
    attrs: {
      "id": "pt1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062237088_Part_1#pt1-1"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Part One: Getting Organized")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_1#ch1-1"
    }
  }, [_vm._v("1.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_1#ch1-1"
    }
  }, [_vm._v("Rules of Engagement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_2#ch2-1"
    }
  }, [_vm._v("2.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_2#ch2-1"
    }
  }, [_vm._v("The Big Decisions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_3#ch3-1"
    }
  }, [_vm._v("3.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_3#ch3-1"
    }
  }, [_vm._v("Budgets, Expenses, and Other Practicalities")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_4#ch4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_4#ch4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Technology and Social Media")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-2",
    attrs: {
      "id": "pt2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062237088_Part_2#pt2-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Part Two: Your Family, Wedding Party, and Guests")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_5#ch5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_5#ch5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wedding Stars")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_6#ch6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_6#ch6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Your Wedding Party")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_7#ch7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_7#ch7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creating Your Guest List")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-2",
    attrs: {
      "id": "pt3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062237088_Part_3#pt3-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Part Three: Invitations and Stationery")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_8#ch8-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_8#ch8-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wedding Invitations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_9#ch9-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_9#ch9-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Invitation Wording")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1a",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_10#ch10-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_10#ch10-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Envelopes and Enclosures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1a",
    attrs: {
      "id": "ch11"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_11#ch11-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_11#ch11-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More from the Stationer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-2",
    attrs: {
      "id": "pt4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062237088_Part_4#pt4-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Part Four: Parties, Presents, and Thanks")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1a",
    attrs: {
      "id": "ch12"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_12#ch12-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_12#ch12-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parties and Celebrations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1a",
    attrs: {
      "id": "ch13"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_13#ch13-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_13#ch13-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gifts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1a",
    attrs: {
      "id": "ch14"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_14#ch14-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_14#ch14-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Importance of “Thank You”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-2",
    attrs: {
      "id": "pt5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062237088_Part_5#pt5-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Part Five: Planning the Big Day")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1a",
    attrs: {
      "id": "ch15"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_15#ch15-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_15#ch15-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Planning Your Ceremony")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1a",
    attrs: {
      "id": "ch16"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_16#ch16-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_16#ch16-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Planning Your Reception")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1a",
    attrs: {
      "id": "ch17"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_17#ch17-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_17#ch17-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wedding Traditions Around the World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1a",
    attrs: {
      "id": "ch18"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_18#ch18-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_18#ch18-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Remarriage: The Encore Wedding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-2",
    attrs: {
      "id": "pt6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062237088_Part_6#pt6-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Part Six: Making It Yours")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1a",
    attrs: {
      "id": "ch19"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_19#ch19-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_19#ch19-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wedding Attire")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1a",
    attrs: {
      "id": "ch20"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_20#ch20-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_20#ch20-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flowers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1a",
    attrs: {
      "id": "ch21"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_21#ch21-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_21#ch21-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Let There Be Music!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1a",
    attrs: {
      "id": "ch22"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_22#ch22-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_22#ch22-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photography and Videography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1a",
    attrs: {
      "id": "ch23"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_23#ch23-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_23#ch23-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Many Layers of Wedding Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-2",
    attrs: {
      "id": "pt7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062237088_Part_7#pt7-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Part Seven: Your Wedding Day")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1a",
    attrs: {
      "id": "ch24"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_24#ch24-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_24#ch24-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wedding Rehearsal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1a",
    attrs: {
      "id": "ch25"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_25#ch25-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_25#ch25-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("At the Wedding Ceremony")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1a",
    attrs: {
      "id": "ch26"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_26#ch26-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_26#ch26-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("At the Reception")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1a",
    attrs: {
      "id": "ch27"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_27#ch27-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27.")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062237088_Chapter_27#ch27-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("After the Wedding")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb1",
    attrs: {
      "id": "app"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062237088_Appendix#app-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: Wedding Planning Checklist")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb",
    attrs: {
      "id": "ind"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062237088_Index#ind-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb",
    attrs: {
      "id": "abt"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062237088_About_the_Author#abt-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb",
    attrs: {
      "id": "also"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062237088_Also_by#also-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also from the Emily Post Institute")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb",
    attrs: {
      "id": "cre"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062237088_Credits#cre-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Credits")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb",
    attrs: {
      "id": "copy"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062237088_Copyright#copy-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb",
    attrs: {
      "id": "atp"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher#atp-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72d276b5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062237088_Contents.vue
// module id = 66
// module chunks = 0